import React from 'react';
import { ApplicationSettings } from '../../../node_modules/titus-ts/dist/js/Settings/ApplicationSettings';
import { NeutralColors } from '@uifabric/fluent-theme/lib/fluent/FluentColors';
import { FontSizes } from '@uifabric/fluent-theme/lib/fluent/FluentType';
import { SELECT_CLASSIFICATION_MODE } from '../../store/select-classification/types';

type PreambleProps = {
    appSettings: ApplicationSettings | null;
    mode: SELECT_CLASSIFICATION_MODE;
    suggestPreamble: string | null;
    schemaFieldsExist: boolean;
};

const Preamble = (props: PreambleProps) => {
    const { appSettings, mode, suggestPreamble, schemaFieldsExist } = props;

    let preambleText;
    switch (mode) {
        case 'portion':
            preambleText = appSettings?.PortionMarkingAdd?.DialogText || 'Please select a portion mark to apply';
            break;
        case 'suggest':
            preambleText = suggestPreamble;
            break;
        default:
            preambleText = appSettings?.MetadataSelectionUi?.DialogPreamble
                ? appSettings?.MetadataSelectionUi?.DialogPreamble
                : 'Please select Classification level(s)';
            break;
    }

    return (
        <div>
            <div
                style={{
                    margin: '32px 8px 16px 8px',
                    borderBottom: schemaFieldsExist ? '1px solid' : '',
                    borderBottomColor: NeutralColors.gray80,
                    fontSize: FontSizes.size14,
                }}
            >
                {preambleText}
            </div>
        </div>
    );
};

export default Preamble;
